"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPopup = exports.Popup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _variables = require("../../styles/variables");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledPopup = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));

exports.StyledPopup = StyledPopup;

var Popup = function Popup(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledPopup, null, props.children);
};

exports.Popup = Popup;
Popup.propTypes = {
  /** Any React Node to be displayed inside the card */
  children: _propTypes["default"].node.isRequired,

  /** Card Width */
  width: _propTypes["default"].string,

  /** Card Height */
  height: _propTypes["default"].string,

  /** Card Background Color */
  backgroundColor: _propTypes["default"].string,

  /** Enables a default padding of 18px on all sides*/
  defaultPadding: _propTypes["default"].bool
};
Popup.defaultProps = {
  width: "100%",
  height: "100%",
  backgroundColor: _variables.colors.ghost,
  defaultPadding: false
};